// KROSSO — Animation System
// Multilingual intro overlay. Scroll reveals + entrance stagger are pure CSS now
// (see krosso.css .krosso-motion-visible rules), driven by the IntersectionObserver
// in custom-liquid.liquid — no GSAP/ScrollTrigger needed. ponytail: GSAP+ScrollTrigger
// (117KB) removed Aug 14, only used for fades a CSS transition-delay already covers.

// ============================================================
// MULTILINGUAL INTRO ANIMATION
// ============================================================

function initIntroAnimation() {
  const overlay = document.getElementById('krosso-intro');
  if (!overlay) return;

  const wordEl = document.getElementById('krosso-intro-word');
  if (!wordEl) return;

  const introWords = [
    { text: 'KROSSO', lang: 'en', tone: 'mark' },
    { text: 'क्रॉसो', lang: 'hi', tone: 'script' },
    { text: 'ક્રોસો', lang: 'gu', tone: 'script' },
    { text: 'ਕ੍ਰੋਸੋ', lang: 'pa', tone: 'script' },
    { text: 'ক্রোসো', lang: 'bn', tone: 'script' },
  ];

  function showWord(item, isBrand) {
    wordEl.classList.remove('visible', 'brand', 'script', 'mark');
    wordEl.textContent = typeof item === 'string' ? item : item.text;
    wordEl.setAttribute('lang', typeof item === 'string' ? 'en' : item.lang);
    if (isBrand) {
      wordEl.classList.add('brand');
    } else if (item.tone === 'script') {
      wordEl.classList.add('script');
    } else {
      wordEl.classList.add('mark');
    }
    void wordEl.offsetWidth;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      wordEl.classList.add('visible');
    }));
  }

  function hideWord() { wordEl.classList.remove('visible'); }

  function dismissOverlay() {
    overlay.style.transition = 'opacity 0.42s cubic-bezier(0.16,1,0.3,1)';
    overlay.style.opacity = '0';
    setTimeout(() => {
      overlay.remove();
      document.documentElement.classList.remove('intro-active');
      document.dispatchEvent(new CustomEvent('krosso:intro-done'));
    }, 420);
  }

  overlay.addEventListener('click', dismissOverlay);
  overlay.addEventListener('touchstart', dismissOverlay, { passive: true });

  // total budget kept under 2s: 5 words @180ms + brand hold 320ms + fade 420ms
  let i = 0;
  function step() {
    if (i < introWords.length) {
      showWord(introWords[i], false);
      i++;
      setTimeout(() => { hideWord(); setTimeout(step, 40); }, 140);
    } else {
      setTimeout(() => {
        showWord({ text: 'KROSSO', lang: 'en', tone: 'mark' }, false);
        setTimeout(() => { hideWord(); setTimeout(dismissOverlay, 80); }, 320);
      }, 50);
    }
  }

  setTimeout(step, 100);
}

// ============================================================
// BOOT
// ============================================================

document.addEventListener('DOMContentLoaded', function () {
  const introOverlay = document.getElementById('krosso-intro');

  if (introOverlay) {
    initIntroAnimation();
  } else {
    document.documentElement.classList.remove('intro-active');
  }
});
